import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";
import i18n from "@/translate/i18n";
import { Title } from "@/components/atoms/Typography/styles";
import { ReactComponent as SuccessIcon } from "@/assets/images/success.svg";
import { LayoutWrapper } from "@/components/molecules/Wrappers/LayoutWrapper";
import { useTransactionData } from "@/context/transactionContext";

const isValidUrl = (urlString) => {
  if (!urlString) return false;
  try {
    return Boolean(new URL(urlString));
  } catch (e) {
    return false;
  }
};
function SucessMessage() {
  const { transactionData: contextData } = useTransactionData();
  const location = useLocation();

  const transactionData = useMemo(() => {
    if (location.state?.data) {
      return location.state.data;
    }
    return contextData;
  }, [location.state, contextData]);

  const hasValidSuccessUrl = useMemo(
    () => isValidUrl(transactionData?.redirect_url_success),
    [transactionData?.redirect_url_success],
  );

  return (
    <LayoutWrapper>
      <div className="flex flex-col items-center">
        <SuccessIcon className="w-14 mt-8" />

        {transactionData?.type === "deposit" ? (
          <>
            <div className="mt-8">
              <Title>{i18n.t("success.title")}</Title>
            </div>
            <h3 className="mt-5 font-medium text-md text-black">
              {i18n.t("success.subtitle")}
            </h3>
          </>
        ) : (
          <>
            <div className="mt-8">
              <Title>{i18n.t("transactionStatus.title")}</Title>
            </div>
            <h3 className="mt-5 font-medium text-md text-black">
              {i18n.t("transactionStatus.subtitle")}
            </h3>
            <h3 className="mt-5 font-medium text-md text-black">
              {i18n.t("transactionStatus.info")}
              <strong>{i18n.t("transactionStatus.info2")}</strong>
            </h3>
          </>
        )}
      </div>

      {transactionData?.type === "withdrawal" && hasValidSuccessUrl && (
        <a
          id="backToMerchant"
          className="mt-20 w-full py-[0.73rem] border border-gray-600 rounded-[50px] bg-cripten-primary text-black cursor-pointer font-arboria-bold text-[calc(0.875em_+_0.2vh)] font-bold hover:brightness-[.85] text-center block"
          href={transactionData?.redirect_url_success}
        >
          {i18n.t("general.backTo", {
            merchant: transactionData?.merchant?.name,
          })}
        </a>
      )}
    </LayoutWrapper>
  );
}

export default SucessMessage;
